export interface ICounts {
    unassigned: number,
    todo: number,
    assignedToMe: number,
    all: number
}